import type { TourSpec } from "./types";

export const flippingTour: TourSpec = {
  id: "flipping",
  version: 3,
  buildSteps: (t) => [
    {
      target: '[data-tour="flipping-region-progress"]',
      title: t("flipping.dataFreshness.title"),
      content: t("flipping.dataFreshness.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="flipping-filter-sidebar"]',
      title: t("flipping.filters.title"),
      content: t("flipping.filters.body"),
      placement: "right",
    },
    {
      target: '[data-tour="filter-mode-toggle"]',
      title: t("filterMode.title"),
      content: t("filterMode.body"),
      placement: "right",
    },
    {
      target: '[data-tour="flipping-stats-section"]',
      title: t("flipping.stats.title"),
      content: t("flipping.stats.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="flipping-data-table"]',
      title: t("flipping.table.title"),
      content: t("flipping.table.body"),
      placement: "top",
    },
    {
      target: '[data-tour="row-actions-menu"]',
      title: t("rowActions.title"),
      content: t("rowActions.body"),
      placement: "bottom-start",
    },
    {
      target: '[data-tour="flipping-pagination"]',
      title: t("flipping.pagination.title"),
      content: t("flipping.pagination.body"),
      placement: "top",
    },
  ],
};
